<template>
	<page-container :page="page" :class="page.headingImage ? '' : 'no-slider'">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
				title: page.title || page.header,
				subtitle: page.subtitle,
			}"
		/>

		<main-content
			:show-title="!page.headingImage"
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
		/>

		<contentblocks v-if="page?.contentblocks && page.contentblocks.length" :contentblocks="page.contentblocks" />
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:subtitle="page.frequentlyAskedQuestion.subtitle"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();
</script>
